export const smartbarnnerClosed = 'smartbanner-closed';
export const smartbarnnerInstalled = 'smartbanner-installed';
